// extracted by mini-css-extract-plugin
export default {"mainContainer":"TextInput_mainContainer__E8XFe"};